import React, { useEffect, useState } from "react";
import { Dropdown } from "primereact";

import { useBuscarInventarioPromedioPorItemGrafico } from "../Service/inventario-service";
import {buscar} from "../../../Commons/Scripts/Utils/Buscar";
import {URL_ALMACENES} from "../Utils/constantes";

const OpcionesPeriodo = [
    { label: "Hoy", value: "diario" },
    { label: "Esta semana", value: "semanal" },
    { label: "Este mes", value: "mensual" },
    { label: "Este trimestre", value: "trimestral" },
    { label: "Este año", value: "anual" },
    { label: "Año anterior", value: "anual_anterior" }
];

const OpcionesTop = [
    { label: "Top 10", value: 10 },
    { label: "Top 25", value: 25 },
    { label: "Top 50", value: 50 },
    { label: "Todos", value: -1 }
]

const PieChart = ({id, data, title, moneda, url }) => {
    function createGrafico() {
        const transformedData = data.map(item => ({
            name: item.Desc,
            value: item.Monto,
            idsec: item.IdSec
        }));

        const chartDom = document.getElementById(id);
        const chart = echarts.init(chartDom, null, { width: "849", height: "390" });

        const options = {
            title: {
                text: title,
                left: "center",
            },
            tooltip: {
                trigger: "item",
                formatter: function (params) {
                    return `<b>${params.name}</b> <br/> ${moneda} ${Citrus.Convert.toCurrencyNoSimbolo(params.value)} (${params.percent}%)`;
                }
            },
            legend: {
                type: 'scroll',
                orient: "vertical",
                left: 'left',
                formatter: function (name) {
                    if (name.length > 25) {
                        return name.slice(0, 25) + '...';
                    }
                    return name;
                }
            },
            color: ['#3fb1e3', '#91cc75', '#fac858', '#ee6666', '#5c7bd9', '#9f8fef'],
            series: [
                {
                    type: 'pie',
                    radius: '50%',
                    label: {
                        fontSize: 12,
                        formatter(param) {
                            return param.percent + '%';
                        },
                        overflow: 'breakAll'
                    },
                    data: transformedData,
                    itemStyle: {
                        borderColor: "#fff",
                        borderWidth: 1,
                    },
                    emphasis: {
                        itemStyle: {
                            shadowBlur: 10,
                            shadowOffsetX: 0,
                            shadowColor: 'rgba(0, 0, 0, 0.5)'
                        }
                    }
                }
            ]
        };

        chart.setOption(options);
        chart.on('click', function (params) {
            if (url != null && params != null && params.data != null && params.data.idsec)
            {
                window.open(`${url}?IdSec=${params.data.idsec}`, "_blank");
            }
        });
    }

    useEffect(() => {
        if (data) {
            createGrafico();
        }
    }, [data, id, title, moneda])

    return <div id={id} className="chart"></div>
};

const Filters = ({ where, setWhere, periodo, setPeriodo, top, setTop, loading,almacen,setAlmacen,opcionesAlmacen }) => {

    const handleChangePeriodo = (e) => {
        setPeriodo(e.value);
        setWhere({ where: { ...where.where, Periodo: e.value } });
    };

    const handleChangeTop = (e) => {
        setTop(e.value);
        setWhere({ where: { ...where.where, Top: e.value } });
    };

    const handleChangeAlmacen = (e) => {
        setAlmacen(e.value);
        setWhere({ where: { ...where.where, AlmacenId: e.value.IdSec } });
    };

    return (
        <div style={{ display: "flex", marginTop: "30px" }}>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-periodo"
                        value={periodo}
                        onChange={handleChangePeriodo}
                        options={OpcionesPeriodo}
                        optionLabel="label"
                        style={{ minWidth: "150px" }}
                        disabled={loading}
                    />
                    <label htmlFor="dd-periodo">Periodo</label>
                </span>
            </div>
            <div className="card flex justify-content-center" style={{ marginRight: "5px" }}>
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-top"
                        value={top}
                        onChange={handleChangeTop}
                        options={OpcionesTop}
                        optionLabel="label"
                        disabled={loading}
                    />
                    <label htmlFor="dd-top">Top</label>
                </span>
            </div>
            <div className="card flex justify-content-center">
                <span className="p-float-label">
                    <Dropdown
                        inputId="dd-Almacen"
                        value={almacen}
                        onChange={handleChangeAlmacen}
                        options={opcionesAlmacen}
                        optionLabel="Descripcion"
                        disabled={loading}
                    />
                    <label htmlFor="dd-top">Almacen</label>
                </span>
            </div>
        </div>
    );
}

export const GraficosPorItem = () => {
    const moneda = window.monedaPredeterminada;

    const [where, setWhere] = useState(null);
    const [periodo, setPeriodo] = useState("mensual");
    const [top, setTop] = useState(10);
    const [almacen, setAlmacen] = useState({ IdSec: 0, Descripcion: "Todos" });
    const [opcionesAlmacen, setOpcionesAlmacen] = useState([{ IdSec: 0, Descripcion: "Todos" }]);
    const {
        data: dataItemsPromedio,
        loading: cargandoItemsPromedio,
        error: errorItemsPromedio,
    } = useBuscarInventarioPromedioPorItemGrafico(where);
    
    const loading = cargandoItemsPromedio;

    useEffect(() => {
        setWhere({where: { Periodo: "mensual", Top: 10 }});
    }, []);

    useEffect(() => {
        let almacenWhere = {where: { Estatus: 'A', EsPaginable: false }}
        buscar(URL_ALMACENES, almacenWhere).then((data) => {
            setOpcionesAlmacen([...opcionesAlmacen, ...data.Resultados])
        })
    }, []);

    if (errorItemsPromedio) {
        return null;
    }

    return (
        <React.Fragment>
            <Filters where={where} setWhere={setWhere} periodo={periodo} setPeriodo={setPeriodo} top={top} setTop={setTop} loading={loading} almacen={almacen} setAlmacen={setAlmacen} opcionesAlmacen={opcionesAlmacen} />
            <div className="card flex justify-content-center">
                <div id="chart_engimat" className="card_row" style={{ marginTop: "50px" }}>
                    <PieChart id="chart_pie_ventas" data={dataItemsPromedio?.Resultados} title="Inventario Promedio por Item" moneda={moneda} url="/Inventario/item_edit.aspx" />
                </div>
            </div>
        </React.Fragment>
    );
}